import { Box, Typography, useTheme } from '@mui/joy';
import { Country, CountryProps } from '../Country/Country';
import { Chapter } from '../../types';
import {
	ChapterPreviewContainer,
	ChapterPreviewContainerProps
} from './ChapterPreviewContainer';
import type {CSSProperties} from "react";

export interface ChapterPreviewProps extends ChapterPreviewContainerProps, Chapter {
	header?: string;
	subheader?: string;
	description?: string;
	countryProps?: Partial<CountryProps>;
	headerSx?: CSSProperties;
	subheaderSx?: CSSProperties;
	largeCountry?: boolean;
}

export const ChapterPreview = ({
	header,
	subheader,
	description,
	countryProps,
	headerSx = {},
	subheaderSx = {},
	largeCountry = false,
	...props
}: ChapterPreviewProps) => {
	const theme = useTheme();
	return (
		<ChapterPreviewContainer
			{...props}
			includeLowerDots
			aria-description={`${header}: ${subheader}`}
		>
			<Box sx={{ height: '0.1px' }}></Box>
			<Box
				sx={{
					marginY: '35px',
					marginX: 'auto',
					backgroundColor: theme.palette.background.surface,
					border: '1px',
					borderStyle: 'solid',
					borderColor: '#4B5563',
					padding: '20px'
				}}
			>
				<Country {...countryProps} animationDelay={1} largeCountry={largeCountry} />
			</Box>
			<Typography
				level='h1'
				sx={{
					...{
						fontSize: '1.235rem',
						lineHeight: '1.75rem',
						fontWeight: 'bold'
					},
					...headerSx}}
			>
				{header}
			</Typography>
			<Typography
				level='h2'
				sx={{
					...{
						fontSize: '1.235rem',
						lineHeight: '1.75rem',
						fontWeight: 'normal',
						letterSpacing: '0px'
					},
					...subheaderSx}}
			>
				{subheader}
			</Typography>
			<Typography
				sx={{
					marginTop: '9px'
				}}
			>
				{description}
			</Typography>
		</ChapterPreviewContainer>
	);
};
